import MgpButton from "../../elements/MgpButton/MgpButton";
import { MAX_MOBILE_WIDTH } from "../../const/AppConst";
import useWindowDimensions from "../../hooks/useWindowDimensions";


type StickButtonsBlocProps = Readonly<{
    showNextButton?: boolean;
    showCenterButton?: boolean;
    showPreviousButton?: boolean;
    previousAction?: () => void;
    centerAction?: () => void;
    nextAction?: () => void;
    nextButtonName?: string;
    previousButtonName?: string;
    centerButtonName?: string;
    disabledPreviousButton?: boolean;
    disabledNextButton?: boolean;
  }>;
  
  export default function StickButtonsBloc({ showNextButton, showPreviousButton, showCenterButton, previousAction, centerAction, nextAction, nextButtonName, previousButtonName, centerButtonName, disabledPreviousButton, disabledNextButton}: StickButtonsBlocProps) {
    let disabledStyle =  {backgroundColor: '', cursor: '', border:''};
    if (disabledPreviousButton) {
      disabledStyle.backgroundColor = "#EFF2F8";
      disabledStyle.cursor = 'not-allowed'; 
      disabledStyle.border = '0';
    }
    if (disabledNextButton) {
      disabledStyle.backgroundColor = "#EFF2F8";
      disabledStyle.cursor = 'not-allowed'; 
      disabledStyle.border = '0';
    }
    const previousClick = (event: any) => {
      if (disabledPreviousButton) {
        event.preventDefault();
      } else if(!disabledPreviousButton){
        if(previousAction) {
          previousAction();
        }
      }
    }

    const centerClick = () => {
      if(centerAction) {
        centerAction();
      }
    }

    const nextClick = (event: any) => {
      if(disabledNextButton) {
        event.preventDefault();
      } else if(!disabledNextButton){
        if(nextAction) {
          nextAction();
        }
      }
    }

    const {width} = useWindowDimensions();
    const isMobile = width <= MAX_MOBILE_WIDTH;  
    
    if (isMobile) {
      return (
        <div className="sticky-buttons-bloc">
            <div className="col-start-4 col-end-5 ">
              {showPreviousButton&&
                <MgpButton
                id="submitButton"
                variant="inverse"
                type="submit"
                color="fushia"
                text={previousButtonName ?? "Retour"}
                icon='chevron-left'
                iconPosition="left"
                onClick={previousClick}
                style={disabledPreviousButton ? disabledStyle : {}}
              ></MgpButton>}
            </div>
            <div className="col-start-5 col-end-6 "></div>
            <div className="col-start-6 col-end-7 bg-blanc">
              {showCenterButton&&<MgpButton
                  id="submitButton"
                  type="button"
                  text={centerButtonName ?? "Commencer"}
                  onClick={centerClick}
                ></MgpButton>}
            </div>
            <div className="col-start-7 col-end-10">
            {showNextButton&&<MgpButton
                id="submitButton"
                type="button"
                text= {nextButtonName ?? "Suivant"}
                icon='chevron-right'
                iconPosition="right"
                onClick={nextClick}
                style={disabledNextButton ? disabledStyle : {}}
              ></MgpButton>}
            </div>
        </div>
    
    );
    }

    return (
        <div className="sticky-buttons-bloc">
            <div className="col-start-5 col-end-6 ">
              {showPreviousButton&&
                <MgpButton
                id="submitButton"
                variant="inverse"
                type="submit"
                color="fushia"
                text={previousButtonName ?? "Retour"}
                icon='chevron-left'
                iconPosition="left"
                onClick={previousClick}
                style={disabledPreviousButton ? disabledStyle : {}}
              ></MgpButton>}
                
            </div>
            <div className="col-start-6 col-end-7 "></div>
            <div className="col-start-7 col-end-8 bg-blanc">
              {showCenterButton&&<MgpButton
                  id="submitButton"
                  type="button"
                  text={centerButtonName ?? "Commencer"}
                  onClick={centerClick}
                      // icon='teleconseiller'
                iconPosition="left"
                ></MgpButton>}
            </div>
            <div className="col-start-9 col-end-11">
            {showNextButton&&<MgpButton
                id="submitButton"
                type="button"
                text={ nextButtonName ?? "Suivant" }
                icon='chevron-right'
                iconPosition="right"
                onClick={nextClick}
                style={disabledNextButton ? disabledStyle : {}}
              ></MgpButton>}
            </div>
        </div>
    );
  }